import { render, staticRenderFns } from "./BrandNapoli.vue?vue&type=template&id=d360c44a&scoped=true&"
import script from "./BrandNapoli.vue?vue&type=script&lang=js&"
export * from "./BrandNapoli.vue?vue&type=script&lang=js&"
import style0 from "./BrandNapoli.vue?vue&type=style&index=0&id=d360c44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d360c44a",
  null
  
)

export default component.exports